import PropTypes from 'prop-types'
import React from 'react'
import { ThemeContext } from 'styled-components'

import ClickableDescr from 'components/ClickableDescr'
import SectionWrapper from 'components/SectionWrapper'
import { ResizeContext } from 'contexts/Resize'
import { useSwitcher } from 'hooks/saveElementIndex'
import { H1Small as H1 } from 'styles/components/typography'

import { Cover, Content, FrameWrapper, FrameBrowserStyled } from './styles'

const IMAGES = ['sport_metabolism', 'sport_risks']

const WResultsSports = props => {
  const { data, pathCdn } = props
  const { index, updateIndex } = useSwitcher()
  const { mobile } = React.useContext(ResizeContext)
  const { colors } = React.useContext(ThemeContext)

  return (
    <SectionWrapper
      isOverflowHidden={true}
      beforeElement={<Cover isTablet={true} />}
    >
      <div className="row">
        <div className="col-12 order-md-1 col-md-8">
          <Cover />
          <FrameWrapper className="py-md-4">
            <div className="position-relative py-4 py-md-0">
              <H1 as="h2" dangerouslySetInnerHTML={{ __html: data.title }} />
              <FrameBrowserStyled
                colorTheme="dark"
                src={`${pathCdn}/${IMAGES[index]}`}
                alt={IMAGES[index]}
              />
            </div>
          </FrameWrapper>
        </div>
        <div className="col-12 py-4 order-md-0 col-md-4">
          <Content>
            <ul className="list--unstyled w-100">
              {data.list.map((item, key) => (
                <ClickableDescr
                  key={key}
                  isActive={index === key}
                  noHover={mobile || data.list.length === 1}
                  onClick={() => updateIndex(key)}
                  bulletColor={colors.orange}
                  arrowPosition="right"
                  data={{
                    title: item.title,
                    description: item.content,
                  }}
                  arrowColor={colors.white}
                />
              ))}
            </ul>
          </Content>
        </div>
      </div>
    </SectionWrapper>
  )
}

WResultsSports.propTypes = {
  data: PropTypes.object.isRequired,
  pathCdn: PropTypes.string.isRequired,
}

export default WResultsSports
